module.exports = __webpack_public_path__ + "img/menu_mens_hifu.2b923bbf.png";